import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DatePicker } from 'antd';
import { subYears } from 'date-fns';
import store from 'store';
import { getTranslatedString } from 'helpers/i18n';
import moment from 'moment';

const BirthdayPicker = ({ minimumAge, ...props }) => {
  const disabledDate = (current) => {
    return current > new Date();
  };
  return (
    <DatePicker
      disabledDate={disabledDate}
      defaultPickerValue={moment().subtract(minimumAge, 'years')}
      {...props}
    />
  );
};

const birthdayPickerMinimumValueValidator = (arg, value) => {
  if (!value) {
    return Promise.reject();
  }

  const minimumAge = store.getState().companyDetails.companyPreferences.minimum_applicant_age;

  if (value > subYears(new Date(), minimumAge)) {
    return Promise.reject(
      getTranslatedString(
        'landlordPortal.applicationManagement.inviteLeadToApply.dateOfBirthLessThanMinimumApplicantAge'
      )
    );
  }

  return Promise.resolve();
};

BirthdayPicker.propTypes = {
  minimumAge: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => {
  return {
    minimumAge: state.companyDetails.companyPreferences.minimum_applicant_age,
  };
};

export { birthdayPickerMinimumValueValidator };

export default connect(mapStateToProps, {})(BirthdayPicker);
